import securityToolsComponents from "../../../../web-sh/src/pages/admin/security-tools/components";

import DataBreachScanner from "./DataBreachScanner";
import PasswordHealth from "./PasswordHealth";

securityToolsComponents.DataBreachScanner = DataBreachScanner;
securityToolsComponents.PasswordHealth = PasswordHealth;

export default securityToolsComponents;